module.exports = __webpack_public_path__ + "static/impact-analysis-mlb-78d831a44339df8260e54db45e017b44.png";